const GET_AGENT: string = "GET_AGENT";
const GET_AGENT_SUCCESS: string = "GET_AGENT_SUCCESS";
const GET_AGENT_FAILURE: string = "GET_AGENT_FAILURE";
const UPDATE_AGENT: string = "UPDATE_AGENT";
const UPDATE_AGENT_SUCCESS: string = "UPDATE_AGENT_SUCCESS";
const UPDATE_AGENT_FAILURE: string = "UPDATE_AGENT_FAILURE";
const ADD_AGENT_EXAMPLE_FAILURE: string = "ADD_AGENT_EXAMPLE_FAILURE";
const ADD_AGENT_EXAMPLE: string = "ADD_AGENT_EXAMPLE";
const ADD_AGENT_EXAMPLE_SUCCESS: string = "ADD_AGENT_EXAMPLE_SUCCESS";
const TEST_AGENT: string = "TEST_AGENT";
const TEST_AGENT_SUCCESS: string = "TEST_AGENT_SUCCESS";
const TEST_AGENT_FAILURE: string = "TEST_AGENT_FAILURE";
const CLEAR_AGENT_TEST: string = "CLEAR_AGENT_TEST";

const GET_INBOX_MESSAGES: string = "GET_INBOX_MESSAGES";
const GET_INBOX_MESSAGES_SUCCESS: string = "GET_INBOX_MESSAGES_SUCCESS";
const GET_INBOX_MESSAGES_FAILURE: string = "GET_INBOX_MESSAGES_FAILURE";
const GET_DRAFTS: string = "GET_DRAFTS";
const GET_DRAFTS_SUCCESS: string = "GET_DRAFTS_SUCCESS";
const GET_DRAFTS_FAILURE: string = "GET_DRAFTS_FAILURE";
const GET_DRAFT_STATS: string = "GET_DRAFT_STATS";
const GET_DRAFT_STATS_SUCCESS: string = "GET_DRAFT_STATS_SUCCESS";
const GENERATE_DRAFT: string = "GENERATE_DRAFT";
const GENERATE_DRAFT_SUCCESS: string = "GENERATE_DRAFT_SUCCESS";
const GENERATE_DRAFT_FAILURE: string = "GENERATE_DRAFT_FAILURE";
const UPDATE_DRAFT_BODY: string = "UPDATE_DRAFT_BODY";
const UPDATE_DRAFT_BODY_SUCCESS: string = "UPDATE_DRAFT_BODY_SUCCESS";
const DECIDE_DRAFT: string = "DECIDE_DRAFT";
const DECIDE_DRAFT_SUCCESS: string = "DECIDE_DRAFT_SUCCESS";
const SEND_DRAFT: string = "SEND_DRAFT";
const SEND_DRAFT_SUCCESS: string = "SEND_DRAFT_SUCCESS";
const SEND_DRAFT_FAILURE: string = "SEND_DRAFT_FAILURE";
const START_WATCH: string = "START_WATCH";
const START_WATCH_SUCCESS: string = "START_WATCH_SUCCESS";
const STOP_WATCH: string = "STOP_WATCH";

const GET_AVATARS: string = "GET_AVATARS";
const GET_AVATARS_SUCCESS: string = "GET_AVATARS_SUCCESS";
const CREATE_AVATAR: string = "CREATE_AVATAR";
const CREATE_AVATAR_SUCCESS: string = "CREATE_AVATAR_SUCCESS";
const CREATE_AVATAR_FAILURE: string = "CREATE_AVATAR_FAILURE";
const SYNC_AVATAR: string = "SYNC_AVATAR";
const SYNC_AVATAR_SUCCESS: string = "SYNC_AVATAR_SUCCESS";
const REQUEST_AVATAR_CONSENT: string = "REQUEST_AVATAR_CONSENT";
const REQUEST_AVATAR_CONSENT_SUCCESS: string = "REQUEST_AVATAR_CONSENT_SUCCESS";
const SET_DEFAULT_AVATAR: string = "SET_DEFAULT_AVATAR";
const SET_DEFAULT_AVATAR_SUCCESS: string = "SET_DEFAULT_AVATAR_SUCCESS";
const SYNC_AVATAR_FAILURE: string = "SYNC_AVATAR_FAILURE";
const REQUEST_AVATAR_CONSENT_FAILURE: string = "REQUEST_AVATAR_CONSENT_FAILURE";
const DELETE_AVATAR_FAILURE: string = "DELETE_AVATAR_FAILURE";
const DELETE_AVATAR: string = "DELETE_AVATAR";
const DELETE_AVATAR_SUCCESS: string = "DELETE_AVATAR_SUCCESS";
const CREATE_DRAFT_VIDEO: string = "CREATE_DRAFT_VIDEO";
const CREATE_DRAFT_VIDEO_SUCCESS: string = "CREATE_DRAFT_VIDEO_SUCCESS";
const CREATE_DRAFT_VIDEO_FAILURE: string = "CREATE_DRAFT_VIDEO_FAILURE";

export const types = {
  GET_AGENT,
  GET_AGENT_SUCCESS,
  GET_AGENT_FAILURE,
  UPDATE_AGENT,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_FAILURE,
  ADD_AGENT_EXAMPLE,
  ADD_AGENT_EXAMPLE_FAILURE,
  ADD_AGENT_EXAMPLE_SUCCESS,
  TEST_AGENT,
  TEST_AGENT_SUCCESS,
  TEST_AGENT_FAILURE,
  CLEAR_AGENT_TEST,
  GET_INBOX_MESSAGES,
  GET_INBOX_MESSAGES_SUCCESS,
  GET_INBOX_MESSAGES_FAILURE,
  GET_DRAFTS,
  GET_DRAFTS_SUCCESS,
  GET_DRAFTS_FAILURE,
  GET_DRAFT_STATS,
  GET_DRAFT_STATS_SUCCESS,
  GENERATE_DRAFT,
  GENERATE_DRAFT_SUCCESS,
  GENERATE_DRAFT_FAILURE,
  UPDATE_DRAFT_BODY,
  UPDATE_DRAFT_BODY_SUCCESS,
  DECIDE_DRAFT,
  DECIDE_DRAFT_SUCCESS,
  SEND_DRAFT,
  SEND_DRAFT_SUCCESS,
  SEND_DRAFT_FAILURE,
  START_WATCH,
  START_WATCH_SUCCESS,
  STOP_WATCH,
  GET_AVATARS,
  GET_AVATARS_SUCCESS,
  CREATE_AVATAR,
  CREATE_AVATAR_SUCCESS,
  CREATE_AVATAR_FAILURE,
  SYNC_AVATAR,
  SYNC_AVATAR_SUCCESS,
  REQUEST_AVATAR_CONSENT,
  REQUEST_AVATAR_CONSENT_SUCCESS,
  SET_DEFAULT_AVATAR,
  SET_DEFAULT_AVATAR_SUCCESS,
  SYNC_AVATAR_FAILURE,
  REQUEST_AVATAR_CONSENT_FAILURE,
  DELETE_AVATAR,
  DELETE_AVATAR_FAILURE,
  DELETE_AVATAR_SUCCESS,
  CREATE_DRAFT_VIDEO,
  CREATE_DRAFT_VIDEO_SUCCESS,
  CREATE_DRAFT_VIDEO_FAILURE,
};
